import { render } from "./akri-works-list-component.vue?vue&type=template&id=2526c959"
import script from "./akri-works-list-component.vue?vue&type=script&setup=true&lang=js"
export * from "./akri-works-list-component.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/arki/views/document/components/akri-works-list-component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2526c959"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2526c959', __exports__)) {
    api.reload('2526c959', __exports__)
  }
  
  module.hot.accept("./akri-works-list-component.vue?vue&type=template&id=2526c959", () => {
    api.rerender('2526c959', render)
  })

}


export default __exports__